"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Theme = {
  name: "DEFAULT",
  "slate-grey": "#666666",
  "almost-black": "#121212",
  white: "#FFFFFF",
  "white-two": "#ececec",
  "almost-white": "#f7f7f7",
  "light-grey": "#f2f3f4",
  grey: "#d2d2d2",
  "grey-two": "#c2c2c2",
  "grey-three": "#e6e6e6",
  "dark-grey": "#666666",
  primary: "#007bff",
  "mlb-blue": "#041e42",
  mlbNavy: "#1e376d",
  "mlb-secondary-blue": "#04152c",
  "mlb-blue:hover": "#003dd2",
  "sky-blue": "#2b77eb",
  "mlb-red": "#ed1c34",
  black: "#000000",
  green: "#00a651",
  "wbc-blue": "#0083c0",
  information: "#ff9100",
  // links
  link: {
    color: "#007bff",
    hover: "#041e42"
  },
  // icons
  icon: {
    color: "#007bff",
    hover: "#041e42",
    size: "1.1rem"
  },
  "focus-color": "#fbf8cb",
  // notifications
  success: {
    background: "#c3e6cb",
    color: "#155724",
    border: "#155724"
  },
  info: {
    background: "#cce5ff",
    color: "#064257",
    border: "#064257"
  },
  danger: {
    background: "#f4dedc",
    color: "#9f3b32",
    border: "#9f3b32"
  },
  border: {
    valid: "#80bdff",
    invalid: "#dc3545"
  },
  boxShadow: {
    valid: "rgba(0,123,255,.25)",
    invalid: "rgba(220,53,69,.25)"
  },
  warning: {
    background: "#fff3cd",
    color: "#856404",
    border: "#856404"
  },
  // hardcoded pixel values
  lineHeight: {
    eventGrid: "21px"
  },
  environment: {
    local: {
      background: "#43c932"
    },
    dev: {
      background: "#e50021"
    },
    stg: {
      background: "#EDB707"
    },
    qa: {
      background: "#1F74BE"
    }
  }
};
var _default = Theme;
exports["default"] = _default;